import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['status']);
  const modifyInvoiceStatus = `modifyInvoiceStatus(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyInvoiceStatus} {
      id
    }
  }
`;
};
